import React from "react";
import Tabs from "@_components/tabs";
import RenderModules from "helpers/render-modules";
import getContainerSizeClass from "@root/helpers/get-container-size-class";

const TabsModule = ({ data }) => {
    if (!data) return null;

    const classes = getContainerSizeClass(data?.moduleSettings);

    return (
        
        <div className={classes.join(" ")}>
            <Tabs>
                {data.items.map((item) => (
                    <div title={item.title} key={`${item.title}`}>
                        <div><RenderModules modules={item.module} /></div>
                    </div>
                ))}
            </Tabs>
        </div>
    );
};

export default TabsModule;
